import { render } from "./AddPanel.vue?vue&type=template&id=53e0d67d&scoped=true"
import script from "./AddPanel.vue?vue&type=script&lang=js"
export * from "./AddPanel.vue?vue&type=script&lang=js"

import "./AddPanel.vue?vue&type=style&index=0&id=53e0d67d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e0d67d"],['__file',"src/assets/js/components/panels/AddPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53e0d67d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53e0d67d', __exports__)) {
    api.reload('53e0d67d', __exports__)
  }
  
  module.hot.accept("./AddPanel.vue?vue&type=template&id=53e0d67d&scoped=true", () => {
    api.rerender('53e0d67d', render)
  })

}


export default __exports__